import React, { ReactNode } from 'react';
import { useUser, useSignIn, useClerk } from '@clerk/clerk-react';

/**
 * useAuth adapter that wraps Clerk's authentication hooks
 */
export const useAuth = () => {
  const { isLoaded, isSignedIn, user } = useUser();
  const { signIn } = useSignIn();
  const { signOut, session } = useClerk();

  // Add getToken for convenience
  const getToken = async () => {
    if (session) {
      return session.getToken();
    }
    return null;
  };

  // Extract email from Clerk user object
  // Prefer primaryEmailAddress field
  let email: string | null = null;
  if (isSignedIn && user) {
    if (user.primaryEmailAddress?.emailAddress) {
      email = user.primaryEmailAddress.emailAddress;
    } else if (Array.isArray((user as any).emailAddresses) && (user as any).emailAddresses.length > 0) {
      email = (user as any).emailAddresses[0].emailAddress;
    }
  }

  return {
    user: isSignedIn ? user : null,
    email,
    loading: !isLoaded,
    signIn,
    signOut,
    getToken,
  };
};

// No AuthProvider needed; ClerkProvider wraps the app
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;